import { pushGtmEvent, markConnectStoreStarted } from './gtmEvents'

/** Logged-in "Connect Amazon"; the teammate invite page passes its own endpoint. */
export var AMAZON_AUTHORIZATION_REDIRECT_URL = '/api/identity/amazon/authorization/redirect'

var START_FAILED = 'Failed to start authorization'

/**
 * Starts Amazon OAuth: asks the backend for the Seller Central consent URL, fires
 * connect_store_started and waits for GTM before leaving the page so the hit isn't lost.
 *
 * @param {Object} http - vue-resource instance (this.$http)
 * @param {Object} options
 * @param {string} [options.url] - redirect endpoint (default: AMAZON_AUTHORIZATION_REDIRECT_URL)
 * @param {Object} options.params - query params for the backend (region, marketplace selection…)
 * @param {Object} [options.gtm] - extra connect_store_started params (region, marketplaces)
 * @param {string} [options.method] - connect_store_success method after the OAuth return
 * @returns {Promise<string>} resolves with the Amazon URL as the page leaves; rejects with an
 *   error message (connect_store_failed is already pushed)
 */
export function startAmazonAuthorization (http, options) {
  var opts = options || {}
  markConnectStoreStarted(opts.method)
  return new Promise(function (resolve, reject) {
    var amazonUrl = null
    var gtmDone = false
    var failed = false
    function goAmazonWhenReady () {
      if (failed || !amazonUrl || !gtmDone) return
      window.location = amazonUrl
      resolve(amazonUrl)
    }
    function fail (message) {
      failed = true
      pushGtmEvent({ event: 'connect_store_failed', error_reason: message })
      reject(message)
    }
    pushGtmEvent(Object.assign({ event: 'connect_store_started', step: 2 }, opts.gtm), function () {
      gtmDone = true
      goAmazonWhenReady()
    })
    http.get(opts.url || AMAZON_AUTHORIZATION_REDIRECT_URL, { params: opts.params }).then(
      function (response) {
        amazonUrl = response.body && response.body.location
        if (!amazonUrl) return fail(START_FAILED)
        goAmazonWhenReady()
      },
      function (response) {
        fail((response.body && response.body.message) || START_FAILED)
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/utils/amazonAuthorizationStart.js